// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lunbo_wrapper__1CDeS","move":"lunbo_move__3yaG0","reverse":"lunbo_reverse__2CBm3","moveReverse":"lunbo_moveReverse__1VkUY"};